export const FRIENDS_AND_FAMILY_DATA_LAYER = {
  FRIENDS_AND_FAMILY_CONGRATS: "friends-and-family-program:congratulations",
  CONTINUE_SHOPPING: "continue shopping",
  FRIENDS_AND_FAMILY_PROGRAM: "friends-and-family-program",
}
